import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from 'react-bootstrap';
import Layout from '../../../../app/Layout';
import HeaderContent from '../../General/HeaderContent';
import Breadcrumb from '../../General/Breadcrumb';
import SpinnerLoading from '../../../components/Spinners/SpinnerLoading';
import { obtenerKpisTutoria } from '../../../../actions/tutoriaHU9Actions';

const KpiCard = ({ titulo, valor, subtitulo, color }) => (
  <div className="col-md-3 col-sm-6 mb-3">
    <div className="box p-3 h-100 text-center" style={{ borderTop: `4px solid ${color}` }}>
      <h2 style={{ color, fontWeight: 700, fontSize: 36 }}>{valor}</h2>
      <p className="mb-1"><strong>{titulo}</strong></p>
      {subtitulo && <small className="text-muted">{subtitulo}</small>}
    </div>
  </div>
);

const EVAL_COLOR = { excelente: 'success', buena: 'primary', regular: 'warning', deficiente: 'danger' };

const KpisTutoria = () => {
  const dispatch = useDispatch();
  const { usuario }                    = useSelector(s => s.usuario);
  const { kpis, loadingKpis }          = useSelector(s => s.tutoriaHU9);

  useEffect(() => {
    if (usuario.id_usuario) {
      dispatch(obtenerKpisTutoria(usuario.id_usuario));
    }
  }, [usuario.id_usuario]);

  if (loadingKpis) return <Layout><SpinnerLoading loading={true} /></Layout>;

  const data = kpis || {};

  const pctAsist = data.total_sesiones > 0
    ? Math.round((data.promedio_conectados / (data.promedio_inscritos || 1)) * 100)
    : 0;

  return (
    <Layout>
      <HeaderContent title="KPIs de Tutoría" icon="chart-bar" />
      <Breadcrumb link={[
        { url: '/inicio',        nombre: 'Inicio',    icon: 'fas fa-home' },
        { url: '',               nombre: 'KPIs de Tutoría' },
      ]} />

      {/* Tarjetas principales */}
      <div className="row mt-3">
        <KpiCard
          titulo="Reportes enviados"
          valor={data.reportes_enviados ?? '—'}
          subtitulo={`de ${data.total_sesiones ?? 0} sesiones`}
          color="#28a745"
        />
        <KpiCard
          titulo="Asistencia promedio"
          valor={`${pctAsist}%`}
          subtitulo={`${data.promedio_conectados ?? 0} conectados / ${data.promedio_inscritos ?? 0} inscritos`}
          color="#17a2b8"
        />
        <KpiCard
          titulo="Protocolo completado"
          valor={`${data.protocolo_pct ?? 0}%`}
          subtitulo="sesiones con protocolo completo"
          color="#6f42c1"
        />
        <KpiCard
          titulo="Enviados a tiempo"
          valor={data.enviados_tiempo ?? '—'}
          subtitulo="reportes dentro del plazo"
          color="#fd7e14"
        />
      </div>

      {/* Distribución de evaluación general */}
      <div className="box p-3 mt-2">
        <h6 className="mb-3"><strong>Evaluación general de sesiones</strong></h6>
        {data.evaluaciones && data.evaluaciones.length > 0 ? (
          <div className="d-flex flex-wrap" style={{ gap: 12 }}>
            {data.evaluaciones.map(ev => (
              <div key={ev.evaluacion_general} className="text-center px-3 py-2" style={{ minWidth: 100 }}>
                <Badge variant={EVAL_COLOR[ev.evaluacion_general] || 'secondary'} className="p-2 d-block mb-1" style={{ fontSize: 16 }}>
                  {ev.cantidad}
                </Badge>
                <small className="text-capitalize">{ev.evaluacion_general || 'Sin dato'}</small>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted">Sin datos aún — completa y envía reportes de sesión para ver estadísticas.</p>
        )}
      </div>

      {/* Tabla de incidencias más frecuentes */}
      {data.incidencias && data.incidencias.length > 0 && (
        <div className="box p-3 mt-2">
          <h6 className="mb-3"><strong>Tipo de incidencias reportadas</strong></h6>
          <table className="table table-sm table-bordered">
            <thead className="thead-light">
              <tr>
                <th>Tipo</th>
                <th className="text-center">Cantidad</th>
              </tr>
            </thead>
            <tbody>
              {data.incidencias.map(inc => (
                <tr key={inc.tipo}>
                  <td className="text-capitalize">{inc.tipo}</td>
                  <td className="text-center">{inc.cantidad}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!data.total_sesiones && (
        <div className="box p-4 text-center text-muted mt-2">
          <p>Aún no hay reportes de sesión enviados. Los KPIs aparecerán cuando el tutor envíe reportes.</p>
        </div>
      )}
    </Layout>
  );
};

export default KpisTutoria;
